import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import VerticalItem from "../../../components/print/workDiary/VerticalItem";
import { getFullName } from "../../../components/util/helpers";
import moment from "moment";
const { Title } = Typography;

const ExtraDetails = (props) => {
  const {
    patient,
    employee,
    staff_worker_in_charge,
    effective_from,
    effective_to,
    max_hours_per_month,
    totalHours,
  } = props;
  const intl = useIntl();

  var age = employee ? moment().diff(employee.birthday, "years") : null;
  const isPensioner =
    employee &&
    ((employee.gender_id === 1 && age >= 67) ||
      (employee.gender_id === 2 && age >= 62));

  let isRelative = false;
  if (
    employee &&
    patient &&
    patient.relative_employees &&
    patient.relative_employees.length > 0
  ) {
    patient.relative_employees.forEach((item, i) => {
      if (item === employee.id) {
        isRelative = true;
      }
    });
  }
  return (
    <div className="borderedSection" style={{ width: "100%" }}>
      <Title level={5}>
        {intl.formatMessage({
          id: "app.work_diary_print.additional_details",
        })}
      </Title>
      <div style={{ display: "flex" }}>
        <div style={{ width: "max-content" }}>
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.employee.staff_worker_in_charge_id",
            })}
          />
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.pensioner",
            })}
          />
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.relative",
            })}
          />
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.effective_from",
            })}
          />
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.effective_to",
            })}
          />
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.max_hours_per_month",
            })}
          />
          <VerticalItem
            content={intl.formatMessage({
              id: "app.work_diary_print.totalHours",
            })}
          />
        </div>
        <div style={{ width: "5px" }} />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <VerticalItem
            content={
              staff_worker_in_charge
                ? getFullName(
                    staff_worker_in_charge.surename,
                    staff_worker_in_charge.first_name
                  )
                : "-"
            }
          />
          <VerticalItem content={isPensioner ? "כן" : "לא"} />
          <VerticalItem content={isRelative ? "כן" : "לא"} />
          <VerticalItem
            content={
              effective_from ? moment(effective_from).format("DD/MM/YYYY") : "-"
            }
          />
          <VerticalItem
            content={
              effective_to
                ? moment(effective_to).format("DD/MM/YYYY")
                : "ללא תאריך סיום"
            }
          />
          <VerticalItem
            content={max_hours_per_month ? max_hours_per_month : "-"}
          />
          <VerticalItem content={totalHours ? totalHours : "-"} />
        </div>
      </div>
    </div>
  );
};

export default ExtraDetails;
